module.exports = __webpack_public_path__ + "img/icon-reporting.42d5c361.svg";